import { Component, OnInit } from '@angular/core';
import { filter, pairwise } from 'rxjs/operators';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router, RoutesRecognized } from '@angular/router';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import { UserService } from 'src/app/core/services/user.service';
import { interval } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { Config } from "../../../config/constants";
@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  transactionId: any;
  firstName: any;
  policyNumber: any;
  purchaserEmail: any;
  lastName: any;
  amount: any;
  policyId: any;
  printPopup:boolean=false;
  viewPolicyDetailsPopup:boolean=false;
  id: any;
  UrlBoxPolicyDownload: any;
  UrlBoxPolicy: any;
  PlanName: string;
  
  constructor(private router: Router,public user: UserService,private base: BaseService,private config:Config) { }

  ngOnInit(): void {
    this.blockUI.start('Your request is being processed. Please do not refresh your screen. Thank you for your patience.');
    localStorage.removeItem('responseID');
    localStorage.removeItem('selectedQuestionprovince1');
    localStorage.removeItem('selectedQuestionlanguages1');
    this.transactionId = localStorage.getItem('transactionID');
    this.firstName = localStorage.getItem('firstName');
    this.lastName = localStorage.getItem('lastName');
    this.amount = localStorage.getItem('amount');
    this.policyNumber=localStorage.getItem('policyNumber');
    this.purchaserEmail=localStorage.getItem('purchaserEmail');
    this.policyId=localStorage.getItem('policyId');
    this.PlanName=localStorage.getItem('PlanName');
    this.router.events
    .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
    .subscribe((events: RoutesRecognized[]) => {
      console.log('previous url', events[0].urlAfterRedirects);
      console.log('current url', events[1].urlAfterRedirects);
    });
   
    this.paymentConfirm();
  //   interval(2000).subscribe(x => {
  //     
  //     this.paymentConfirm();
  // });
  this.id=setInterval(() => {
    
    this.paymentConfirm(); 
  }, 2000);
    // this.blockUI.stop() 
  }
  paymentConfirm(){
    
    // if(this.policyId != null){
    //   this.blockUI.stop();
    // }else{
    //   this.blockUI.start('Your request is being processed. Please do not refresh your screen. Thank you for your patience.');
    // }
    this.transactionId = localStorage.getItem('transactionID');
    this.firstName = localStorage.getItem('firstName');
    this.lastName = localStorage.getItem('lastName');
    this.amount = localStorage.getItem('amount');
    this.policyNumber=localStorage.getItem('policyNumber');
    this.purchaserEmail=localStorage.getItem('purchaserEmail');
    this.paymentConfirm1();
  }
  paymentConfirm1(){
   // this.blockUI.stop();
    this.transactionId = localStorage.getItem('transactionID');
    this.firstName = localStorage.getItem('firstName');
    this.lastName = localStorage.getItem('lastName');
    this.amount = localStorage.getItem('amount');
    this.policyNumber=localStorage.getItem('policyNumber');
    this.purchaserEmail=localStorage.getItem('purchaserEmail');
    console.log(this.policyId)
    if(this.policyId != null){
      
      clearInterval(this.id);
      this.blockUI.stop();
    }else{
      this.blockUI.start('Your request is being processed. Please do not refresh your screen. Thank you for your patience.');
    }
  }
  email=[];
  email1="";
  email2="";
  emailErrorFlag: boolean=false;
  clear(){
    this.emailNotValid1="";
    this.emailNotValid="";
  }
  onSendEmail(){
    this.email=[];
    if(this.emailNotValid1=="" && this.emailNotValid==""){
    if(!this.email1){this.emailErrorFlag=true}else{this.emailErrorFlag=false}
    if(this.emailErrorFlag==false){
      this.email.push(this.email1)
      if(this.email2!=null && this.email2!=""){
      this.email.push(this.email2)
    }
    this.blockUI.start();
      this.user.emailSendStart(this.email,this.policyId).pipe()
      .subscribe(
          data => {
            this.email=[]
            this.email1=""
            this.email2=""
            this.emailErrorFlag=false;
            this.printPopup=false;
            this.blockUI.stop();
            // Swal.fire('',data.message,'success'); 
            Swal.fire('','Email sent successfully.','success');     
          },error=>{},()=>{});
    }
  }
  }



  downloadLink: any;
  onPolicyCoc(){
  
    this.user.getViewCocCheck(this.policyId).pipe()
    .subscribe(
        data => {
    this.downloadLink = data.data;
    saveAs(this.downloadLink, "PolicyCOC"+".pdf");
        },error=>{},()=>{});
      }
     
  
  onRemoveEmailError(){
    this.emailErrorFlag=false;
    }
  emailNotValid: string="";
  emailCheck(){
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  
  if (!re.test(this.email1.toLowerCase())){
    this.emailNotValid="Please enter valid Email";
  }else{
    this.emailNotValid="";
  }
  }
  emailNotValid1: string="";
  emailCheck1(){
    if(this.email2!=""){
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  
      if (!re.test(this.email2.toLowerCase())){
        this.emailNotValid1="Please enter valid Email";
      }else{
        this.emailNotValid1="";
      }
    }
    else{
      this.emailNotValid1="";
    }
  }
  onSelectedBoxFile(){
    // Test server 
    // this.fileId=973944120504
    // Prod
   
    // var fileId=973640479796
    //
    this.PlanName= "Visitors to Canada Emergency Medical Insurance(VTC)"
    if(this.PlanName!== "Visitors to Canada Emergency Medical Insurance(VTC)"){
    this.user.getLeadPreviewLinkSales().pipe()
    .subscribe(
        data => {
  
         //(data.data)
         this.UrlBoxPolicy=data.data.previewLink;
         this.UrlBoxPolicyDownload=data.data.downloadLink;
     
        },error=>{
       
          
        
            },()=>{});
    
      setTimeout(() => 
  {
    this.viewPolicyDetailsPopup = !this.viewPolicyDetailsPopup;
  },
  2000);
}
  else{
    this.user.PreviewLinkVtc().pipe()
.subscribe(
    data => {

     //(data.data)
     this.UrlBoxPolicy=data.data.previewLink;
     this.UrlBoxPolicyDownload=data.data.downloadLink;
     saveAs(this.UrlBoxPolicyDownload, "PolicyCOC"+".pdf");
    },error=>{
   
      
    
        },()=>{});
        setTimeout(() => 
        {
          this.viewPolicyDetailsPopup = !this.viewPolicyDetailsPopup;
        },
        2000);
        
  }
}
downloadPolicyWording(){
  var win = window.open(this.UrlBoxPolicyDownload, '_blank');
}
  getPolicyDocs(){
    this.base.callGetServiceCall(this.config.getPolicyDocsByPolicyId+this.policyId).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,this.policyNumber)
      }
    },error=>{{
    }},()=>{});
  }
}
